import React from 'react';
import { useMouseScrubVideo } from './useMouseScrubVideo';
const DESKTOP_VIDEO_URL = "/hf_20260615_071721_b9b9a20a-f009-4e0b-9528-f6757ceb8b2c.mp4";
const MOBILE_VIDEO_URL = "/hf_20260615_110129_2f9712e9-411f-4f0e-a227-3079412406ba.mp4";
/**
 * Full-bleed hero background: a grayscale video the user scrubs by moving the
 * mouse horizontally, with a fading halftone dot-grid layered on top. Sits
 * behind the hero content (z-0) and is non-interactive.
 */
export function HeroVideoBackground() {
  const desktopVideoRef = useMouseScrubVideo<HTMLVideoElement>();
  const mobileVideoRef = useMouseScrubVideo<HTMLVideoElement>();
  return <div className="absolute inset-0 z-0 pointer-events-none" data-id="element-2998" data-mp="3qb6wsrvl94c5">
      {/* Desktop Video */}
      <video ref={desktopVideoRef} src={DESKTOP_VIDEO_URL} muted playsInline preload="auto" className="absolute inset-0 h-full w-full object-cover hidden md:block mix-blend-multiply" style={{
      objectPosition: '70% center'
    }} data-id="element-2999" data-mp="3ubz7zqo0tjb2" />
      {/* Mobile Video */}
      <video ref={mobileVideoRef} src={MOBILE_VIDEO_URL} muted playsInline preload="auto"
    // Scale up to zoom in, translate down to push the head away from the text
    // and crop out the bottom of the torso.
    className="absolute inset-0 h-full w-full object-contain block md:hidden scale-[1.5] translate-y-[15%] mix-blend-multiply" style={{
      objectPosition: 'center bottom'
    }} data-id="element-3000" data-mp="1cy52d9fvk3kf" />

      {/* Fading halftone dot-grid overlay */}
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(rgba(43, 33, 26, 0.15) 0.8px, transparent 0.9px)',
      backgroundSize: '8px 8px',
      maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0.55) 45%, rgba(0,0,0,0) 85%)',
      WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0.55) 45%, rgba(0,0,0,0) 85%)'
    }} data-id="element-3001" data-mp="u0auwzuea045" />
    </div>;
}